import {Badge, Box, DataList, Flex, Grid, GridItem, HStack, IconButton, Separator, Stack, Text} from "@chakra-ui/react";
import {UI} from "components";
import {useColorMode} from "components/ui-old/color-mode";
import {Mask} from "config";
import useReport from "hooks/useReport";
import moment from "moment";
import {useState} from "react";
import {Line, LineChart, ResponsiveContainer, Tooltip, XAxis} from "recharts";

export default function Analytics() {

    const colorMode = useColorMode()
    const [date, setDate] = useState(moment().startOf('month'))
    const report = useReport(date, moment(date).endOf('month'))
    const data = report.data?.sales_daily?.map(item => ({date: item.date, daily_growth: item.daily_growth}))

    const handleChangeDate = (type) => {
        if (type === 'sub') setDate(moment(date).subtract(1, 'month'))
        if (type === 'add') setDate(moment(date).add(1, 'month'))
    }

    return (
        <>
            <UI.Header title="Relatórios"/>

            <Flex justifyContent="space-between" mb={8}>
                <Box>
                    <IconButton variant="ghost" onClick={() => handleChangeDate('sub')}>
                        <UI.Icon name="left"/>
                    </IconButton>
                </Box>
                <Box><Badge size="lg">{moment(date).format('MMMM/Y')}</Badge></Box>
                <Box>
                    <IconButton variant="ghost" onClick={() => handleChangeDate('add')}>
                        <UI.Icon name="right"/>
                    </IconButton>
                </Box>
            </Flex>

            <ResponsiveContainer width="100%" height={200}>
                <LineChart data={data} margin={{top: 125, right: 20, left: 20, bottom: 0}}>
                    {/* <CartesianGrid strokeDasharray="3 3" stroke="#444" /> */}
                    <XAxis dataKey="date" tickFormatter={value => moment(value).format('DD/MM')} stroke="#ccc"/>
                    {/* <YAxis dataKey="daily_growth" stroke="#ccc" tickFormatter={value => `${Mask.price(value)}`} /> */}
                    {/* <Tooltip /> */}
                    <Line
                        type="monotone"
                        dataKey="daily_growth"
                        stroke="#38B2AC"
                        strokeWidth={3}
                        // dot={{ r: 4, stroke: "#38B2AC", strokeWidth: 2, fill: "#fff" }}
                        // activeDot={{ r: 6 }}
                        label={{
                            position: "top",
                            fill: colorMode.colorMode === 'dark' ? '#FFF' : '#333',
                            style: {fontSize: 11, fontWeight: 'bold'},
                            formatter: value => `R$ ${Mask.price(value)}`
                        }}
                        labelFormatter={value => `R$ ${Mask.price(value)}`}
                    />
                    <Tooltip labelFormatter={e => `Total de vendas`}
                             formatter={value => `R$ ${Mask.price(value)}`}
                             contentStyle={{backgroundColor: 'rgba(0,0,0,0.9)', border: 0, borderRadius: '6px'}}/>
                </LineChart>
            </ResponsiveContainer>

            <Grid templateColumns={{base: '1fr', sm: '1fr', md: 'repeat(3, 1fr)', lg: 'repeat(3, 1fr)'}} gap={4}>

                <GridItem>
                    <UI.Box loading={report.isFetching} p={4}>
                        <Stack gap={4}>
                            <Text fontSize="xs" color="GrayText">Resumo financeiro:</Text>

                            <Box>
                                <Text fontSize="xs">Total em vendas:</Text>
                                <Text fontSize="lg" fontWeight="bold" color="green.fg">
                                    <UI.Number.Amount value={report.data?.financial?.['sales']}/>
                                </Text>
                            </Box>

                            <Box>
                                <Text fontSize="xs">Saldo utilizado:</Text>
                                <Text fontSize="md" fontWeight="bold" color="red.fg">-
                                    <UI.Number.Amount value={report.data?.financial?.['debits']}/>
                                </Text>
                            </Box>

                            <Separator/>
                            <Text fontSize="xs" color="GrayText">Detalhamento:</Text>

                            <DataList.Root orientation="horizontal" gap={2}>
                                <DataList.Item>
                                    <DataList.ItemLabel>Presencial:</DataList.ItemLabel>
                                    <DataList.ItemLabel>
                                        <UI.Number.Amount value={report.data?.financial?.['in_person']}/>
                                    </DataList.ItemLabel>
                                </DataList.Item>

                                <DataList.Item>
                                    <DataList.ItemLabel>Bonificação:</DataList.ItemLabel>
                                    <DataList.ItemLabel>
                                        <UI.Number.Amount value={report.data?.financial?.['bonus']}/>
                                    </DataList.ItemLabel>
                                </DataList.Item>

                                <DataList.Item>
                                    <DataList.ItemLabel>Pix:</DataList.ItemLabel>
                                    <DataList.ItemLabel>
                                        <UI.Number.Amount value={report.data?.financial?.['pix']}/>
                                    </DataList.ItemLabel>
                                </DataList.Item>
                            </DataList.Root>
                        </Stack>
                    </UI.Box>
                </GridItem>

                <GridItem>
                    <UI.Box loading={report.isFetching} p={4}>
                        <Stack gap={4}>
                            <Text fontSize="xs" color="GrayText">Produtos mais vendidos:</Text>

                            {report.data?.products?.map(item => (
                                <HStack key={item.product}>
                                    <Box>
                                        <Text fontSize="xs" fontWeight="bold">{item.product}</Text>
                                        <Text fontSize="xs" color="GrayText">{item.total} vendas</Text>
                                    </Box>
                                </HStack>
                            ))}

                        </Stack>
                    </UI.Box>
                </GridItem>

                <GridItem>
                    <UI.Box loading={report.isFetching} p={4}>
                        <Stack gap={4}>
                            <Text fontSize="xs" color="GrayText">Maiores clientes:</Text>

                            {report.data?.consultants?.map(item => (
                                <HStack key={item.customer_name}>
                                    <UI.Avatar size="xs" name={item.customer_name}/>
                                    <Box>
                                        <Text textTransform="capitalize" fontSize="xs"
                                              fontWeight="bold">{item.customer_name}
                                        </Text>
                                        <Text fontSize="xs" color="GrayText"><Text as="span" color="green.fg">
                                            <UI.Number.Amount value={item.total}/>
                                        </Text> em compras</Text>
                                    </Box>
                                </HStack>
                            ))}
                        </Stack>
                    </UI.Box>
                </GridItem>
            </Grid>
        </>
    )
}
